import type { FaireProductEntity } from "../../entity_types/product";

export const p_e7hnrhmw9w: FaireProductEntity = {
  token: "p_e7hnrhmw9w",
  type: "product",
  name: "Front Pockets Cozy Chunky Knit Loose Fit Cardigan MMY274",
  brandToken: "b_9qqlp5kqt7",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/54de94aea905341e49cc5f884b10bc8abc2cd387766fae5af5a8cc1b69fb872e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f2a4ae219a204516e4a74e3c82c056bd2316fd0238789d0e632986da9a54d54f.jpeg",
    "https://cdn.faire.com/fastly/cbbc93f56a67791e2bf1005083c6d42917d3f49ab072a9c7b87cdf0c168694b9.jpeg",
    "https://cdn.faire.com/fastly/5d182a0b1b19b10394d97d9d37d142aab66e91f70347bd2327479adf4cc1c935.jpeg",
    "https://cdn.faire.com/fastly/a470cf2e85e34b1e10d229131cc0eaf6f58e8680276eb08f873a8835e1b148d3.jpeg",
  ],
  priceDollars: 33.95,
  description:
    "Warm Chunky Knit Fabric: Made from thick, textured yarn that offers superior warmth and a soft, cozy feel—perfect for cooler weather.\n\nRelaxed Loose Fit: The oversized silhouette provides a laid-back look while ensuring comfort and easy layering over your favorite tops.\n\nFunctional Front Pockets: Features two spacious front pockets, adding both style and practicality for keeping your hands warm or storing small essentials.\n\nEffortlessly Stylish: The simple yet chic design makes it easy to pair with jeans, leggings, or dresses for a casual yet put-together outfit.\n\nGo-To Layering Piece: Ideal for lounging at home, running errands, or cozying up outdoors—this cardigan is a must-have fall and winter staple.\n\nSize Chart (cm)\t\t\t\n\t\t\t\nSize\tBust\tSleeve\tLength\nS\t110.0 \t48.0 \t64.0 \nM\t114.0 \t49.0 \t65.0 \nL\t120.0 \t50.0 \t67.0 \nXL\t126.0 \t51.0 \t69.0 \n\nSize Chart (inch)\t\t\t\n\t\t\t\nSize\tBust\tSleeve\tLength\nS\t43.3 \t18.9 \t25.2 \nM\t44.9 \t19.3 \t25.6 \nL\t47.2 \t19.7 \t26.4 \nXL\t49.6 \t20.1 \t27.2 \n",
  tags: [],
  msrpDollars: 67.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:30.284Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
